module.exports = __webpack_public_path__ + "static/img/2.b2e3034.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newFive/2.png
// module id = yK23
// module chunks = 0